'use client'

import { Box } from '@mui/material'

import { useDestinationContext } from '@/src/contexts'

import DestinationOverviewWrapper from './destinationOverview'
import PlacesToVisitWrapper from './placesToVisit'
import ThingsToDoWrapper from './thingsToDo'
import AreasToStayWrapper from './areasToStay'
import DestinationClimateWrapper from './destinationClimate'
import CostOfLivingWrapper from './costOfLiving'
import DestinationQuickFactsWrapper from './destinationQuickFacts'
import PopularRoutesWrapper from './popularRoutes'
import DestinationFaqWrapper from './destinationFaq'
import DestinationEditorialMetaWrapper from './destinationEditorialMeta'

const DestinationSectionsWrapper = () => {
    const { destinationData: { meta } } = useDestinationContext()
    const isAi = meta.contentMode === 'ai'

    if (!isAi) {
        return (
            <Box sx={{ minWidth: 0, overflow: 'hidden' }}>
                <PopularRoutesWrapper />
                <DestinationFaqWrapper />
            </Box>
        )
    }

    return (
        <Box sx={{ minWidth: 0, overflow: 'hidden' }}>
            <DestinationOverviewWrapper />
            <PlacesToVisitWrapper />
            <ThingsToDoWrapper />
            <AreasToStayWrapper />
            <DestinationClimateWrapper />
            <CostOfLivingWrapper />
            <DestinationQuickFactsWrapper />
            <PopularRoutesWrapper />
            <DestinationFaqWrapper />
            <DestinationEditorialMetaWrapper />
        </Box>
    )
}

export default DestinationSectionsWrapper
